module.exports = __webpack_public_path__ + "static/img/animales_38.671ddcf9.png";